<template>
  <div class="pt-8 flex flex-col lg:flex-row p-4 min-h-screen bg-light-bg dark:bg-dark-bg dark:text-dark-text">
    <AppSidebar />

    <div class="flex flex-col flex-grow p-6 lg:p-12 space-y-4 h-full">
      <!-- Wiadomość sukcesu lub błędu -->
      <div v-if="message" :class="messageType" 
          class="fixed top-0 left-0 right-0 z-5 p-4 rounded-lg mb-4 text-center 
                  bg-white dark:bg-dark-box-bg dark:text-dark-text dark:border 
                  dark:border-dark-border">
          {{ message }}
          <div class="absolute bottom-0 left-0 h-1 rounded-lg" 
              :style="{ width: progress + '%', backgroundColor: getProgressColor(), borderRadius: '8px' }">
          </div>
      </div>

      <h1 class="text-xl md:text-2xl font-bold mb-4 text-center lg:text-left">Firmy</h1>

      <CompanyCreateModal
          :isOpen="showCreateModal"
          @close="closeCreateModal"
          @submit="handleCreateSubmit"
      />

      <CompanyEditModal
          :isOpen="showEditModal"
          :editingCompany="editingCompany"
          @close="closeEditModal"
          @submit="handleEditSubmit"
      />

      <div class="bg-white p-4 rounded-lg shadow-md w-full h-auto overflow-visible dark:bg-dark-box-bg dark:border dark:border-dark-border">
        <div class="flex flex-col md:flex-row items-start md:items-center justify-between mb-4">
          <h2 class="text-lg font-semibold text-gray-700 dark:text-dark-text">Lista Firm</h2>

          <button @click="goToArchive()" class="px-4 py-2 text-sm font-medium bg-teal-700 text-white rounded-md hover:bg-teal-800 dark:bg-teal-600 dark:hover:bg-teal-500 transition-colors"> Archiwum </button>

          <DynamicSearch
              :data="companies"
              :keysToSearch="['companyName', 'companyNip', 'companyAddress', 'phone']"
              @search-results="handleSearchResults"
              @clear-search="clearSearch"
              class="mt-4 bg-gray-200 dark:bg-dark-box-bg text-gray-900 dark:text-dark-text w-full md:w-auto"
              placeholder="Wyszukaj..."
          />
        </div>

        <div class="overflow-x-auto w-full">
          <table class="min-w-full bg-white border border-gray-300 rounded-lg dark:bg-dark-table-bg dark:border-dark-border">
            <thead>
            <tr class="bg-gray-50 dark:bg-dark-table-header">
              <th class="py-3 px-4 border-b border-gray-300 dark:border-dark-border text-left text-sm font-semibold text-gray-700 dark:text-dark-text">
                Nazwa firmy
              </th>
              <th class="py-3 px-4 border-b border-gray-300 dark:border-dark-border text-left text-sm font-semibold text-gray-700 dark:text-dark-text">
                NIP
              </th>
              <th class="py-3 px-4 border-b border-gray-300 dark:border-dark-border text-left text-sm font-semibold text-gray-700 dark:text-dark-text">
                Adres
              </th>
              <th class="py-3 px-4 border-b border-gray-300 dark:border-dark-border text-left text-sm font-semibold text-gray-700 dark:text-dark-text">
                Telefon
              </th>
              <!-- <th class="py-3 px-4 border-b border-gray-300 dark:border-dark-border text-right text-sm font-semibold text-gray-700 dark:text-dark-text">
                Akcje
              </th> -->
            </tr>
            </thead>
            <tbody>
            <tr v-if="filteredCompanies.length === 0">
              <td colspan="5" class="text-center py-4 text-red-500 font-semibold dark:text-dark-status-unavailable">
                Brak firm
              </td>
            </tr>
            <tr
                v-else
                v-for="(company) in paginatedCompanies"
                :key="company.id"
                :class="[
                    'border-b border-gray-300 dark:border-dark-border hover:bg-light-hover dark:hover:bg-dark-hover hover:cursor-pointer',
                    selectedCompany && company.id === selectedCompany.id ? 'bg-light-hover dark:bg-dark-hover' : ''
                ]"
            >
              <td @click="showCompanyDetails(company)" class="py-3 px-4 dark:text-dark-text">{{ company.companyName }}</td>
              <td class="py-3 px-4 dark:text-dark-text">{{ company.companyNip }}</td>
              <td class="py-3 px-4 dark:text-dark-text">{{ company.companyAddress }}</td>
              <td class="py-3 px-4 dark:text-dark-text">{{ company.phone }}</td>
              <!-- <td class="py-3 px-4 text-right dark:text-dark-text">
                <div class="relative inline-block text-left">
                  <button @click.stop="toggleDropdown(company.id)" class="text-gray-500 hover:text-gray-700 dark:text-dark-text">
                    <EllipsisVerticalIcon class="h-5 w-5" />
                  </button>
                  <div v-if="dropdownOpen === company.id" class="origin-top-right absolute left-0 ml-[-10rem] mt-[-2.2rem] w-40 focus:outline-none">
                    <div class="py-1.5 absolute flex space-x-2 bg-gray-200 dark:bg-gray-900 rounded">
                      <button @click.stop="goToProfile(company)" class="text-left px-2 py-2 text-sm text-teal-700 dark:text-teal-400 flex items-center space-x-2">
                        <UserIcon class="w-4 h-4" />
                      </button>
                      <button @click.stop="startEditing(company)" class="text-left px-2 py-2 text-sm text-teal-700 dark:text-teal-400 flex items-center space-x-2">
                        <PencilIcon class="w-4 h-4" />
                      </button>
                      <button v-if="['ROLE_ADMIN'].includes(user.role)" @click.stop="deleteCompany(company.id)" class="text-left px-2 py-2 text-sm text-teal-700 dark:text-teal-400 flex items-center space-x-2">
                        <TrashIcon class="w-4 h-4" />
                      </button>
                    </div>
                  </div>
                </div>
              </td> -->
            </tr>
            </tbody>
          </table>
        </div>

        <!-- Paginacja -->
        <div class="mt-4 flex flex-col sm:flex-row items-center justify-between space-y-4 sm:space-y-0">
          <!-- Informacja o liczbie wyświetlanych elementów -->
          <div class="text-center sm:text-left text-sm text-light-text dark:text-gray-400">
            Wyświetlono {{ (currentPage - 1) * itemsPerPage + paginatedCompanies.length }} z {{ filteredCompanies.length }} firm
          </div>

          <!-- Kontrolki paginacji -->
          <div class="flex flex-wrap justify-center sm:justify-end items-center gap-2">
            <button v-if="currentPage > 1"
                    @click="goToPage(1)"
                    class="px-3 py-1 text-sm font-medium bg-light-table-header rounded-md dark:bg-dark-table-header dark:text-dark-text">
              Pierwsza strona
            </button>
            <button v-if="currentPage > 1"
                    @click="prevPage"
                    class="px-3 py-1 text-sm font-medium bg-light-table-header rounded-md dark:bg-dark-table-header dark:text-dark-text">
              &laquo; Poprzednia
            </button>
            <button v-for="page in visiblePages"
                    :key="page"
                    @click="goToPage(page)"
                    :class="[currentPage === page ? 'bg-teal-700 text-white' : 'bg-gray-200 dark:bg-dark-box-bg text-gray-700 dark:text-dark-text']"
                    class="px-3 py-1 text-sm font-medium rounded-md transition-colors hover:bg-teal-700 hover:text-white dark:hover:bg-teal-600 dark:hover:text-white">
              {{ page }}
            </button>
            <button v-if="currentPage < totalPages"
                    @click="nextPage"
                    class="px-3 py-1 text-sm font-medium bg-light-table-header rounded-md dark:bg-dark-table-header dark:text-dark-text">
              Następna &raquo;
            </button>
            <button v-if="currentPage < totalPages"
                    @click="goToPage(totalPages)"
                    class="px-3 py-1 text-sm font-medium bg-light-table-header rounded-md dark:bg-dark-table-header dark:text-dark-text">
              Ostatnia strona
            </button>
          </div>
        </div>
      </div>
    </div>

    <button
        v-if="!showCreateModal && !editingCompany && user.role !== 'ROLE_YOUNG_DISPATCHER'"
        @click="openCreateModal"
        class="fixed bottom-8 right-8 bg-button-bg text-button-text p-4 rounded-full shadow-md transition-transform duration-200 ease-in-out hover:bg-button-hover dark:bg-dark-button-bg dark:hover:bg-dark-button-hover"
    >
      <PlusIcon class="h-6 w-6 transition-transform duration-200 ease-in-out transform hover:rotate-45" />
    </button>
  </div>
  <CompanyInformationModal
            v-if="showModal"
            :visible="showModal"
            :title="'Szczegóły Firmy #' + (selectedCompany?.id || '')"
            :selectedCompany="selectedCompany"
            :userRole="user.role"
            @close="closeModalInformation"
            @goToProfile="goToProfile"
            @startEditing="startEditing"
            @deleteCompany="deleteCompany"
      >
          <div class="space-y-4">
            <p><b>ID Firmy:</b> {{ selectedCompany?.id }}</p>
            <p><b>Nazwa firmy:</b> {{ selectedCompany?.companyName }}</p>
            <p><b>NIP:</b> {{ selectedCompany?.companyNip }}</p>
            <p><b>Adres:</b> {{ selectedCompany?.companyAddress }}</p>
            <p><b>Numer telefonu:</b> {{ selectedCompany?.phone }}</p>
            <p><b>Tylko AB:</b> {{ selectedCompany?.onlyAB ? 'Zaznaczono' : 'Niezaznaczono' }}</p>
            <p><b>Rozszerzona faktura:</b> {{ selectedCompany?.extendedInvoice ? 'Zaznaczono' : 'Niezaznaczono' }}</p>
            <p><b>Inicjały:</b> {{ selectedCompany?.initials }}</p>
          </div>
  </CompanyInformationModal>
</template>


<script>
import {useAuthStore} from '@/stores/authStore';
import companiesService from '@/services/companiesService';
import AppSidebar from "@/components/AppSidebar.vue";
import CompanyCreateModal from './CompanyCreateModal.vue';
import CompanyEditModal from './CompanyEditModal.vue';
import DynamicSearch from '../search/DynamicSearch.vue';
import {PlusIcon} from "@heroicons/vue/24/solid";
import CompanyInformationModal from './CompanyInformationModal.vue';
import { useSessionStore } from '@/stores/useSessionStore';

export default {
  name: "CompaniesPageDispatcher",
  components: {
    PlusIcon,
    AppSidebar,
    CompanyCreateModal,
    CompanyEditModal,
    DynamicSearch,
    CompanyInformationModal
  },
  setup() {
    const authStore = useAuthStore();
    const sessionStore = useSessionStore();
    const user = authStore.user;
    return {user, sessionStore};
  },
  data() {
    return {
      message: '',
      messageType: '',
      progress: 0,
      showCreateModal: false,
      showEditModal: false,
      companies: [],
      filteredCompanies: [],
      editingCompany: null,
      loading: false,
      dropdownOpen: null,
      currentPage: 1,
      itemsPerPage: 5,
      totalPages: 0,
      visiblePages: [],
      showModal: false,
      selectedCompany: null,
      isSearching: false,

      newCompany: {
        companyName: '',
        companyNip: '',
        companyAddress: '',
        phone: '',
        onlyAB: false,
        extendedInvoice: false
      },
      errors: {
        companyName: '',
        companyNip: '',
        companyAddress: '',
        phone: '',
        onlyAB: false,
        extendedInvoice: false
      }
    };
  },
  mounted() {
    this.calculateItemsPerPage();
    window.addEventListener("resize", this.calculateItemsPerPage);

    const pageFromUrl = parseInt(this.$route.query.currentPage) || 1;
    this.currentPage = pageFromUrl;

    this.fetchCompanies().then(() => {
      this.calculateTotalPages();
    });

    this.refreshCompany();
  },
  beforeUnmount() {
    if (this.sessionStore.intervalId) {
      clearInterval(this.sessionStore.intervalId); // Oczyść interval, jeśli jest ustawiony
      this.sessionStore.intervalId = null; // Reset interval to prevent any issues if it tries to be cleared again
    }
    window.removeEventListener("resize", this.calculateItemsPerPage);
  },
  computed: {
    paginatedCompanies() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredCompanies.slice(start, end);
    }
  },
  methods: {
    refreshCompany() {
      this.sessionStore.startInterval(() => {
        if(!this.isSearching) {
            this.fetchCompanies();
        }
      }, 10000);
    },
    calculateItemsPerPage() {
      const width = window.innerWidth;

      if (width >= 3840) {
        this.itemsPerPage = 32; // 4K monitor
      } else if (width >= 2560) {
        this.itemsPerPage = 20; // 2K monitor
      } else if (width >= 1920) {
        this.itemsPerPage = 15; // Full HD monitor
      } else {
        this.itemsPerPage = 10; // Standardowa wartość
      }

      this.calculateTotalPages();
    },
    showCompanyDetails(company) {
      this.selectedCompany = company; // Przypisz wybrane zamówienie
      this.showModal = true; // Pokaż modal
    },
    closeModalInformation() {
      this.selectedCompany = null; // Wyczyść dane zamówienia
      this.showModal = false; // Zamknij modal
    },
    calculateTotalPages() {
      this.totalPages = Math.ceil(this.filteredCompanies.length / this.itemsPerPage) || 1;
      this.updateVisiblePages();
    },
    updateVisiblePages() {
      const range = 5; // Liczba widocznych stron
      const start = Math.max(1, this.currentPage - Math.floor(range / 2));
      const end = Math.min(start + range - 1, this.totalPages);

      this.visiblePages = Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },
    goToPage(page) {
      this.currentPage = page;
      this.updateVisiblePages();
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.updateVisiblePages();
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.updateVisiblePages();
      }
    },
    showMessage(msg, type) {
      this.message = msg;
      this.messageType = type === 'success' ? 'success-message' : 'error-message';
      this.progress = 0;

      const interval = 30;
      const duration = 5000;
      const step = 100 / (duration / interval);

      const progressInterval = setInterval(() => {
        this.progress += step;
        if (this.progress >= 100) {
          clearInterval(progressInterval);
          this.progress = 0;
          this.message = '';
          this.messageType = '';
        }
      }, interval);
    },
    getProgressColor() {
      return this.messageType === 'success-message' ? '#16a34a' : '#b91c1c';
    },
    toggleDropdown(companyId) {
      this.dropdownOpen = this.dropdownOpen === companyId ? null : companyId;
    },
    async fetchCompanies() {
      try {
        const response = await companiesService.getAllCompanies();
        this.companies = response.data;
        this.filteredCompanies = this.companies;
      } catch (error) {
        console.error('Błąd podczas pobierania firm:', error);
      }
    },
    openCreateModal() {
      this.showCreateModal = true;
    },
    closeCreateModal() {
      this.showCreateModal = false;
    },
    async handleCreateSubmit(newCompany) {
      if (this.loading) return;
      this.loading = true;

      try {
        await companiesService.createCompany(newCompany);
        await this.fetchCompanies();
        this.closeCreateModal();
        this.showMessage("Firma została pomyślnie dodana.", "success");
      } catch (error) {
        console.error('Błąd podczas tworzenia firmy:', error);
        this.showMessage("Wystąpił błąd podczas dodawania firmy.", "error");
      } finally {
        this.loading = false;
      }
    },
    startEditing(company) {
      this.editingCompany = {...company};
      this.showModal = false;
      this.showEditModal = true;
    },
    closeEditModal() {
      this.showEditModal = false;
      this.editingCompany = null;
    },
    async handleEditSubmit(updatedCompany) {
      if (this.loading) return;
      this.loading = true;

      try {
        await companiesService.updateCompany(updatedCompany.id, updatedCompany);
        await this.fetchCompanies();
        this.closeEditModal();
        this.showMessage("Firma została pomyślnie zaktualizowana.", "success");
      } catch (error) {
        console.error('Błąd podczas aktualizacji firmy:', error);
        this.showMessage("Wystąpił błąd podczas aktualizacji firmy.", "error");
      } finally {
        this.loading = false;
      }
    },
    async deleteCompany(companyId) {
      if (confirm("Czy na pewno chcesz usunąć tę firmę?")) {
        try {
          await companiesService.deleteCompany(companyId);
          await this.fetchCompanies();
          this.showMessage("Firma została pomyślnie usunięta.", "success");
          this.closeModalInformation();
        } catch (error) {
          console.error('Błąd podczas usuwania firmy:', error.response.data.message || error.message);
          this.showMessage(error.response.data.message, "error");
        }
      }
    },
    goToProfile(company) {
      const currentPage = this.currentPage; 

      if (this.user.role === 'ROLE_ADMIN') {
        this.$router.push({
          name: 'CompanyProfileAdmin', 
          params: {id: company.id},
          query: {
            returnTo: this.$route.name,
            currentPage: currentPage,
          }
        });
      } else {
        this.$router.push({
          name: 'CompanyProfileDispatcher', 
          params: {id: company.id},
          query: {
            returnTo: this.$route.name,
            currentPage: currentPage,
          }
        });
      }
    },
    goToArchive() {
      const currentPage = this.currentPage; 

      if (this.user.role === 'ROLE_ADMIN') {
        this.$router.push({
          name: 'CompaniesArchivePageAdmin', 
          query: {
            returnTo: this.$route.name,
            currentPage: currentPage,
          }
        });
      } else {
        this.$router.push({
          name: 'CompaniesArchivePageDispatcher', 
          query: {
            returnTo: this.$route.name,
            currentPage: currentPage,
          }
        });
      }
    },
    handleSearchResults(results) {
      this.filteredCompanies = results;
      this.calculateTotalPages();

      this.isSearching = results.length > 0;

      this.goToPage(1);
    },
    clearSearch() {
      this.isSearching = false;

      this.goToPage(1);
    }
  }
};
</script>

